import * as types from "./actionType";

const initialState = {
  loading: false,
  tourLoading: false,
  toursList: [],
  toursListCount: 0,
  toursPendingCount: 0,
  toursDetails: null,
  createTourStatus: false,
  updateTourInfo: [],
  documentUpload: null,
  documentUploadStatus: false,
  documentRead: [],
  updatedDetails: null,
  fetchingUpdatedDetails: false,
  documentReadStatus: false,
  binaryDocument: null,
};

function toursReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TOURS_LIST:
      return {
        ...state,
        loading: true,
        tourLoading: true,
      };
    case types.FETCH_TOURS_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        tourLoading: false,
        toursList: action.payload,
        toursListCount: action.count,
        toursPendingCount: action.pendingCount
      };
    }
    case types.FETCH_TOURS_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        tourLoading: false,
        toursList: [],
        toursListCount: 0,
      };
    }
    case types.FETCH_TOURS_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_TOURS_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        toursDetails: action.payload,
      };
    }
    case types.FETCH_TOURS_DETAILS_FAILED: {
      return {
        ...state,
        loading: false,
        toursDetails: {},
      };
    }
    case types.CREATE_TOUR:
      return {
        ...state,
        createTourStatus: true,
      };
    case types.CREATE_TOUR_SUCCESS: {
      return {
        ...state,
        createTourStatus: false,
      };
    }
    case types.CREATE_TOUR_FAILED: {
      return {
        ...state,
        createTourStatus: false,
      };
    }
    case types.UPDATE_TOUR_INFO:
      return {
        ...state,
        updateTourInfo: [],
      };
    case types.UPDATE_TOUR_INFO_SUCCESS: {
      return {
        ...state,
        updateTourInfo: action.payload,
      };
    }
    case types.UPDATE_TOUR_INFO_FAILED: {
      return {
        ...state,
        updateTourInfo: [],
      };
    }
    case types.UPLOAD_URL:
      return {
        ...state,
        documentUploadStatus: true,
        documentUpload: null,
      };
    case types.UPLOAD_URL_SUCCESS: {
      return {
        ...state,
        documentUploadStatus: false,
        documentUpload: action.payload,
      };
    }
    case types.UPLOAD_URL_FAILED: {
      return {
        ...state,
        documentUploadStatus: false,
        documentUpload: null,
      };
    }

    case types.READ_URL:
      return {
        ...state,
        documentReadStatus: true,
      };
    case types.READ_URL_SUCCESS: {
      return {
        ...state,
        documentReadStatus: false,
        documentRead: action.payload,
      };
    }
    case types.READ_URL_FAILED: {
      return {
        ...state,
        documentReadStatus: false,
        documentRead: [],
      };
    }

    case types.UPLOAD_BINARY_URL:
      return {
        ...state,
        binaryDocument: null,
      };
    case types.UPLOAD_BINARY_URL_SUCCESS: {
      return {
        ...state,
        binaryDocument: action.payload,
      };
    }
    case types.UPLOAD_BINARY_URL_FAILED: {
      return {
        ...state,
        binaryDocument: null,
      };
    }

    case types.TOURS_UPDATE_DETAILS:
      return {
        ...state,
        fetchingUpdatedDetails: true,
      };
    case types.TOURS_UPDATE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchingUpdatedDetails: false,
        updatedDetails: action.payload,
      };
    case types.TOURS_UPDATE_DETAILS_FAILED:
      return {
        ...state,
        fetchingUpdatedDetails: false,
        updatedDetails: null,
      };

    default:
      return state;
  }
}

export default toursReducer;
